import { isDeviceManager } from '@/util/util'

export const UNIV_MANAGER_ROLE_CODES = [
  'admin',
  'Manager',
  'SystemOperations',
  'UniversityLeader',
]

export const UNIT_MANAGER_ROLE_CODES = [
  'CollegeSafetyManager',
  'CollegeLeader',
  'FacultyDean',
]

/**
 * @param {object | null | undefined} device
 * @returns {string}
 */
export function getDeviceUnitId(device) {
  if (!device) return ''
  if (device.belong && device.belong.unit_id != null && device.belong.unit_id !== '') {
    return String(device.belong.unit_id)
  }
  if (device.unit_id != null && device.unit_id !== '') {
    return String(device.unit_id)
  }
  return ''
}

/**
 * @param {{ role_codes?: string[] } | null | undefined} userInfo
 * @returns {boolean}
 */
export function hasUnivManagerRole(userInfo) {
  if (!userInfo || !Array.isArray(userInfo.role_codes)) {
    return false
  }
  return userInfo.role_codes.some(code =>
    UNIV_MANAGER_ROLE_CODES.includes(code)
  )
}

/**
 * @param {{ role_codes?: string[] } | null | undefined} userInfo
 * @returns {boolean}
 */
export function hasUnitManagerRole(userInfo) {
  if (!userInfo || !Array.isArray(userInfo.role_codes)) {
    return false
  }
  return userInfo.role_codes.some(code =>
    UNIT_MANAGER_ROLE_CODES.includes(code)
  )
}

/**
 * 是否可查看某设备的「设备数据看板」入口
 * - 设备管理员（负责人/联系人）
 * - 校级管理员：全部设备
 * - 院系管理员（非校级）：仅本院系设备
 *
 * @param {object | null | undefined} device
 * @param {{ user_id?: string, role_codes?: string[] } | null | undefined} userInfo
 * @param {string | number | null | undefined} managedUnitId
 * @returns {boolean}
 */
export function canAccessDevicePanel(device, userInfo, managedUnitId) {
  if (!device || !userInfo || !userInfo.user_id) {
    return false
  }

  if (isDeviceManager(device, userInfo.user_id)) {
    return true
  }

  if (hasUnivManagerRole(userInfo)) {
    return true
  }

  if (hasUnitManagerRole(userInfo) && !hasUnivManagerRole(userInfo)) {
    const deviceUnitId = getDeviceUnitId(device)
    if (deviceUnitId && managedUnitId != null && managedUnitId !== '') {
      return deviceUnitId === String(managedUnitId)
    }
  }

  return false
}

/**
 * @param {{ role_codes?: string[] } | null | undefined} userInfo
 * @returns {boolean}
 */
export function hasStatisticsRole(userInfo) {
  return hasUnivManagerRole(userInfo) || hasUnitManagerRole(userInfo)
}

/**
 * @param {boolean} isLoggedIn
 * @param {{ role_codes?: string[] } | null | undefined} userInfo
 * @returns {boolean}
 */
export function canAccessStatistics(isLoggedIn, userInfo) {
  return isLoggedIn && hasStatisticsRole(userInfo)
}
